<template>
  <div style="display: inline-block">
    <el-checkbox
      v-model="value[name]"
      :label="setting.label || name"
      border
      class="has-text-grey"
      style="margin-bottom: 1em; margin-right: 5px"
    />
    <Tooltip :label="setting.label || name" :content="setting.detail" />
  </div>
</template>

<script>
/**
 * Boolean SmartField - Renders a checkbox input for boolean configuration values.
 *
 * @component
 * @description Displays a bordered checkbox with label and tooltip for boolean module settings.
 * Automatically initializes value from setting.default if not already set.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the checkbox (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {boolean} [setting.default] - Default value if not set
 * @prop {string} name - Property key in the value object
 *
 * @example
 * <Boolean
 *   :value="config"
 *   :setting="{ label: 'Enable Feature', detail: 'Enable this feature', default: false }"
 *   name="enabled"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name"],
  mounted() {
    if (this.value[this.name] == null && typeof this.value === "object") {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
